export default "__VITE_ASSET__DDE0nLDK__"